import axios from 'axios'

/**
 * Cliente Axios base para todos los servicios admin-crm.
 *
 * Anti-spam notificaciones (Roger 23-may-2026):
 *  - Cancelaciones de request (navegación, abort): NUNCA disparan catch
 *    devolvemos una Promise pending eterna → silencio total.
 *  - 401 sesión expirada: redirigimos a login (no notif spam).
 *  - Network Error / status 0 puntuales: dejamos pasar (algunos catches
 *    sí quieren notificar al usuario que falló).
 */
class Gateway {
  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_GATEWAY_BASE_URL,
      withCredentials: true,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      // ADD YOUR BEARER JETSTREAM TOKEN TO TEST
      headers: { Authorization: 'Bearer ' + process.env.REACT_APP_GATEWAY_TOKEN },
    })

    // SIR-76 (2026-08-18): además del Bearer maestro (que sólo prueba "soy el frontend"),
    // adjuntamos en cada petición el token de sesión del usuario (remember_token) que /login
    // devuelve y guardamos en sessionStorage['token']. El gateway lo exige (cabecera X-Auth-Token)
    // en las rutas de datos del CRM; sin él responde 401. Va en cabecera, NO en la query string,
    // para que Apache no lo registre en el access log (#45/#67).
    this.client.interceptors.request.use((config) => {
      try {
        const raw = sessionStorage.getItem('token')
        if (raw) {
          const sessionToken = JSON.parse(raw)
          if (sessionToken) {
            config.headers['X-Auth-Token'] = sessionToken
          }
        }
      } catch {
        // sin sesión (login, recuperar contraseña): se envía sólo el Bearer maestro.
      }
      return config
    })

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        // 1) CANCELACIONES (la primera fuente de notif-spam en CRM): devolver
        // una promesa pending eterna → el .catch del caller NO se dispara.
        if (
          error?.code === 'ERR_CANCELED' ||
          error?.code === 'ECONNABORTED' ||
          error?.name === 'CanceledError' ||
          error?.message === 'canceled' ||
          error?.__CANCEL__ === true
        ) {
          return new Promise(() => {})
        }

        // 2) 401 sesión expirada: limpiar y redirigir a login una sola vez.
        if (error?.response?.status === 401) {
          if (!window.__sessionExpiredHandled) {
            window.__sessionExpiredHandled = true
            try {
              sessionStorage.clear()
            } catch {
              // ignore
            }
            // Redirect tras pequeño delay para que la pestaña no quede ciega.
            setTimeout(() => {
              window.location.assign('/')
            }, 50)
          }
          // No propagamos como rechazo → catches NO disparan notif spam.
          return new Promise(() => {})
        }

        // 3) Resto: rechazar normal (errores reales → catch puede notificar).
        return Promise.reject(error)
      },
    )
  }
}

export default Gateway
